export interface BranchStoreBody {
  branchStoreId: number;
  branchStoreReceptionId: number;
}

export interface ProductsBody {
  productId: number;
  typeProductId: number;
  codeProduct: string;
  lot: string;
  description: string;
  expAt: string;
  formats: any;
}

export enum STATUS_TRANSFER {
  CREADO = 1,
  ACEPTADO = 2,
  ANULADO = 3
}
